var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatalogComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 299,
    viewBox: "0 0 335 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 163,
    r: 120,
    fill: "#353A4D",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 163,
    r: 105,
    fill: "#353A4D",
    fillOpacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 163,
    r: 85,
    fill: "#353A4D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 163,
    r: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.902 143.591C183.479 141.756 186.344 141.466 188.302 142.943C190.11 144.307 190.513 146.7 189.324 148.504L188.994 148.941L160.244 182.409C158.723 184.18 156.017 184.502 154.084 183.227L153.652 182.904L138.506 170.125C136.638 168.549 136.487 165.851 138.169 164.1C139.722 162.484 142.294 162.239 144.15 163.451L144.598 163.784L156.168 173.547L181.902 143.591Z",
    fill: "#00D2B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 61.5C34.6944 61.5 38.5 57.6944 38.5 53C38.5 48.3056 34.6944 44.5 30 44.5C25.3056 44.5 21.5 48.3056 21.5 53C21.5 57.6944 25.3056 61.5 30 61.5Z",
    fill: "white",
    stroke: "#00D2B7",
    strokeOpacity: 0.6,
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z",
    fill: "#00D2B7",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25C77.2091 25 79 23.2091 79 21C79 18.7909 77.2091 17 75 17C72.7909 17 71 18.7909 71 21C71 23.2091 72.7909 25 75 25Z",
    fill: "#00D2B7",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.5 295.5C295.194 295.5 299 291.694 299 287C299 282.306 295.194 278.5 290.5 278.5C285.806 278.5 282 282.306 282 287C282 291.694 285.806 295.5 290.5 295.5Z",
    fill: "white",
    stroke: "#00D2B7",
    strokeOpacity: 0.6,
    strokeWidth: 7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M330.5 163C332.709 163 334.5 161.209 334.5 159C334.5 156.791 332.709 155 330.5 155C328.291 155 326.5 156.791 326.5 159C326.5 161.209 328.291 163 330.5 163Z",
    fill: "#00D2B7",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogComplete);
export default __webpack_public_path__ + "static/media/catalog-complete.2fd05671e26a306ea8891140f78c72fc.svg";
export { ForwardRef as ReactComponent };